import { SectionHeading } from './SectionHeading';
import { CaseCard } from './CaseCard';
import { cases } from '../content/site';
import styles from './CasesSection.module.css';
export function CasesSection() {
  return (
    <section className={styles.section} id="cases">
      <SectionHeading eyebrow="Проекты" title="Опыт, за которым стоят реальные объекты" />
      <div className="grid grid-cols-1 gap-3 md:grid-cols-2">
        {cases.map((x) => (
          <CaseCard key={x.name} project={x} />
        ))}
      </div>
    </section>
  );
}
